import ActionFooter from './actionFooter'
import ConnectPage from './connectPage'
import EthereumRpcPage from './ethereumRpcPage'
import NetworkPage from './networkPage'
import PermissionPage from './permissionPage'
import SignaturePage from './signaturePage'
import TransactionPage from './transactionPage'

export default {
  ActionFooter,
  ConnectPage,
  EthereumRpcPage,
  NetworkPage,
  PermissionPage,
  SignaturePage,
  TransactionPage
}
